import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import PdfViewer from '../PdfViewer/PdfViewer'

export default class ProjectDocuments extends React.Component {
  constructor(props) {
    super(props)
    this.projectDocuments            = this.props.projectDocumentsData.projectDocuments
    this.handleProjectDocumentClick  = this.handleProjectDocumentClick.bind(this)
    this.acceptTermsForDocument      = this.acceptTermsForDocument.bind(this)
    this.handleTermsOfServices       = this.handleTermsOfServices.bind(this)
    this.toggleSubmitButton          = this.toggleSubmitButton.bind(this)
    this.allTermsForDocumentAccepted = this.allTermsForDocumentAccepted.bind(this)

    this.state = {
      openPdfViewer: false,
      termsOfServices: false,
      projectDocuments: this.projectDocuments,
      selectedProjectDocumentId: null,
      pdfViewerProps: this.props.projectDocumentsData.pdfViewer
    }
  }

  componentDidMount() {
    this.toggleSubmitButton(true)
  }

  // Set new pdfViewerProps and re-render components
  handleProjectDocumentClick(projectDocumentId) {
    let { openPdfViewer, pdfViewerProps } = this.state
    // if projectDocuments contains projectDocumentId
    if(projectDocumentId && this.projectDocuments.hasOwnProperty(projectDocumentId.toString())) {
      pdfViewerProps['contractDocument'] = this.projectDocuments[projectDocumentId]
      openPdfViewer = true
    } else {
      openPdfViewer = false
    }

    this.setState({ openPdfViewer: openPdfViewer, pdfViewerProps: pdfViewerProps, selectedProjectDocumentId: projectDocumentId })
  }

  acceptTermsForDocument(projectDocumentId) {
    let { projectDocuments } = this.state
    // if projectDocuments contains projectDocumentId
    if(projectDocumentId && projectDocuments.hasOwnProperty(projectDocumentId.toString())) {
      projectDocuments[projectDocumentId]['termsAccepted'] = true
    }
    this.setState({ projectDocuments: projectDocuments })
  }

  allTermsForDocumentAccepted() {
    let { projectDocuments } = this.state
    return Object.values(projectDocuments).reduce((acc, value, index, array) => {
      return (value.termsAccepted === false) ? false : acc
    }, true)
  }

  handleTermsOfServices(event) {
    // Ugly hack because checkbox with keen won't work in IE11
    if (event.target.name == 'project[terms_of_service]') {
      let terms_of_service_checked = $('#project_terms_of_service').prop('checked')
      $('#project_terms_of_service').prop('checked', !terms_of_service_checked)
      terms_of_service_checked = $('#project_terms_of_service').prop('checked')
      this.setState({ termsOfServices: terms_of_service_checked })
      this.toggleSubmitButton(!terms_of_service_checked)
    }
  }

  toggleSubmitButton(isDisabled) {
    let target = $('.k-form__actions input[type=submit]')
    isDisabled ? target.hide() : target.show()
  }

  render() {
    const { openPdfViewer, pdfViewerProps, projectDocuments, selectedProjectDocumentId } = this.state
    const { i18n } = this.props.projectDocumentsData

    return (
      <React.Fragment>
        <div className='table-responsive'>
          <table className='table table-striped vertical-align-middle'>
            <tbody>
              { projectDocuments && Object.keys(projectDocuments).map( (key, index) => {
                const projectDocument = projectDocuments[key]

                if (projectDocument) {
                  return (
                    <tr key={key}>
                      <td className='text-center'>
                        <i className={`fa ${projectDocument.termsAccepted ? "fa-check k-font-success" : "fa-times k-font-danger"} fa-lg`}></i>
                      </td>
                      <td>{projectDocument.title}</td>
                      <td>
                        <a
                          href='#'
                          onClick={() => this.handleProjectDocumentClick(projectDocument.id)}>
                          {i18n['read_the']} {projectDocument.title}
                        </a>
                      </td>
                    </tr>
                  )
                }
              })}
            </tbody>
          </table>
        </div>

        {(openPdfViewer &&
          <PdfViewer
            {...pdfViewerProps}
            i18n={i18n}
            closePdfViewer={this.handleProjectDocumentClick}
            selectedProjectDocumentId={selectedProjectDocumentId}
            acceptTermsForDocument={this.acceptTermsForDocument} />
        )}

        <div className='k-separator k-separator--height-md'></div>

        {(this.allTermsForDocumentAccepted() &&
          <div className='form-group boolean required project_terms_of_service'>
            <label className='k-checkbox k-checkbox--brand' onClick={this.handleTermsOfServices}>
              <input name='project[terms_of_service]' type='hidden' value='0'/>
              <input className='boolean required' checked={this.state.termsOfServices} onChange={this.handleTermsOfServices} required='required' aria-required='true' type='checkbox' value='1' name='project[terms_of_service]' id='project_terms_of_service'/>
              {i18n['accept_terms_text']}
              <span className=''></span>
            </label>
          </div>
        )}

      </React.Fragment>
    )
  }
}

// Typechecking With PropTypes https://reactjs.org/docs/typechecking-with-proptypes.html
ProjectDocuments.propTypes = {
  projectDocumentsData: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./app/frontend/packs/ProjectDocuments/ProjectDocuments.jsx